export let baseUrl = process.env.VUE_APP_ENDPOINT;
export let selfUrl = process.env.VUE_APP_STARTPOINT;
export let wsBaseUrl = process.env.VUE_APP_WSENDPOINT;